import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'

import Form from 'components/form/Form'

import adminActions from 'store/modules/admin'
import adminSelectors from 'store/selectors/admin'
import bookingformActions from 'store/modules/bookingform'
import bookingformSelectors from 'store/selectors/bookingform'
import routerActions from 'store/modules/router'
import routerSelectors from 'store/selectors/router'


const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(4),
  },
  marginTop: {
    marginTop: theme.spacing(2),
  },
  buttons: {
    marginTop: theme.spacing(4),
  },
  copyButton: {
    margin: theme.spacing(2),
  },
  actionButton: {
    marginLeft: theme.spacing(1),
  },
  configField: {
    width: '100%',
  }
}))

const BookingFormGeneric = ({
  title,
  schema,
  getButtons,
  processPayload,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const error = useSelector(adminSelectors.saveBookingform.error)
  
  const { id } = useSelector(routerSelectors.params)
  const data = useSelector(bookingformSelectors.editBookingForm)
  const initialValues = data || {}

  const onCancel = useCallback(() => {
    dispatch(routerActions.navigateTo('admin.bookingforms.list'))
  })

  const onSubmit = useCallback((payload) => {
    payload = processPayload ? processPayload(payload) : payload
    dispatch(adminActions.saveBookingform(id, payload))
  }, [
    id,
    processPayload,
  ])

  useEffect(() => {
    if(id == 'new') {
      dispatch(bookingformActions.setConfigs([]))
    }
    else {
      dispatch(bookingformActions.loadAdminBookingforms())
      dispatch(bookingformActions.loadAdminBookingformConfigs(id))
    }
  }, [
    id,
  ])

  if(id != 'new' && !data || (data && data.id != id)) return null

  return (
    <div className={ classes.root }>
      <Grid container spacing={ 4 }>
        <Grid item xs={ 12 } md={ 12 }>
          <Paper className={ classes.paper }>
            <Typography gutterBottom variant="h6">
              Booking Form: { title }
            </Typography>
            <Form
              schema={ schema }
              error={ error }
              initialValues={ initialValues }
              onSubmit={ onSubmit }
            >
              {
                ({
                  isValid,
                  values,
                  onSubmit,
                }) => {
                  return (
                    <div className={ classes.buttons }>
                      {
                        getButtons && getButtons({
                          values,
                        })
                      }
                      <Button
                        className={ classes.actionButton }
                        variant="contained"
                        onClick={ onCancel }
                      >
                        Cancel
                      </Button>
                      <Button
                        className={ classes.actionButton }
                        variant="contained"
                        color="primary"
                        onClick={ onSubmit }
                      >
                        Save
                      </Button>
                    </div>
                  )
                }
              }
            </Form>
          </Paper>
        </Grid>
      </Grid>
    </div>
  )
}

export default BookingFormGeneric